import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	LikeSupporterVoiceComment,
	type LikeSupporterVoiceCommentMutation,
	type LikeSupporterVoiceCommentMutationVariables,
} from './index.graphql';

export async function likePetitionSupporterComment({
	commentId,
	utilityContext: {
		gql: { fetch },
	},
}: {
	commentId: string;
	utilityContext: UtilityContext;
}): Promise<LikeSupporterVoiceCommentMutation | null | undefined> {
	const { data: likeResult } = await fetch<
		LikeSupporterVoiceCommentMutation,
		LikeSupporterVoiceCommentMutationVariables
	>({
		query: LikeSupporterVoiceComment,
		variables: { commentId },
		rejectOnError: true,
	});
	return likeResult;
}
